import { ChangeDetectionStrategy, Component, Injector, ViewEncapsulation, inject } from '@angular/core';
import { TabsModuleBase } from '@fi-app/utilities/tabs/tabs-module-base';
import { BehaviorSubject } from 'rxjs';
import { ChecklistV2StatesService } from '@fi-app/checklist/checklist-v2/checklist-v2-states.service';
import { FiChecklistHelperService } from '@fi-shared/checklist/fi-checklist-helper.service';
import { FiChecklist2ReportHelperService } from '@fi-shared/checklist/fi-checklist2-report/services/fi-checklist2-report-helper.service';
import { takeUntil } from 'rxjs/operators';
import { FiStateNames } from '@fi-app/shared/fi-state-proxy/fi-state-names';
import { ObjectTypes } from '@fi-shared/types';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { FiChecklist2ScheduleDialogService } from '@fi-app/shared/checklist/schedule/services/fi-checklist2-schedule-dialog.service';
import { FiChecklist2ScheduleFactoryService } from '@fi-app/shared/checklist/schedule/services/fi-checklist2-schedule-factory.service';

@Component({
    selector: 'fi-checklist-v2-list-audit-navigation-tabs',
    templateUrl: './checklist-v2-list-audit-navigation-tabs.component.html',
    styleUrls: ['./checklist-v2-list-audit-navigation-tabs.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-checklist-v2-list-audit-navigation-tabs' },
    standalone: false,
})
export class ChecklistV2ListAuditNavigationTabsComponent extends TabsModuleBase {
    FiStateNames = FiStateNames;
    isNavBarHidden$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    private checklistV2StatesService = inject(ChecklistV2StatesService);
    private fiChecklistHelperService = inject(FiChecklistHelperService);
    private fiChecklist2ReportHelperService = inject(FiChecklist2ReportHelperService);
    private pageTitleService = inject(PageTitleService);
    private fiChecklist2ScheduleDialogService = inject(FiChecklist2ScheduleDialogService);
    private fiChecklist2ScheduleFactoryService = inject(FiChecklist2ScheduleFactoryService);

    constructor(injector: Injector) {
        super(injector);
    }

    ngOnInit() {
        this.tabs = this.checklistV2StatesService.getChecklistV2AuditSettingsTabs();

        super.updateSelectedTabFromState();
        this.subscribeOnHideNavBar();
        this.pageTitleService.setTitleByItem(ObjectTypes.Checklist2Audit);
    }

    private subscribeOnHideNavBar() {
        this.fiChecklist2ReportHelperService
            .getPageNavBarVisibility$()
            .pipe(takeUntil(this.ngOnDestroy$))
            .subscribe((isHidden: boolean) => this.isNavBarHidden$.next(isHidden));
    }

    openAddDialog() {
        const sref = this.getAddSref();
        if (sref === FiStateNames.ChecklistV2Audit.Add._name) {
            this.fiChecklistHelperService.openAddChecklistDialog(true);
        }
        if (sref === FiStateNames.ChecklistV2Audit.Template.Add._name) {
            this.fiChecklistHelperService.openAddChecklistTemplateDialog(true);
        } else if (sref === FiStateNames.ChecklistV2Audit.Schedule.Add) {
            this.fiChecklist2ScheduleDialogService.openAddChecklistScheduleDialog(
                this.fiChecklist2ScheduleFactoryService.getChecklistScheduleInstance(true),
                true,
            );
        }
    }

    openAddReportWidgetDialog() {
        this.fiChecklist2ReportHelperService.triggerAddNewWidgetOpenDialog();
    }

    showAddButton(): boolean {
        const addSref = this.getAddSref();
        return addSref && addSref !== FiStateNames.ChecklistV2Audit.Report.Dashboard;
    }

    isReportState(): boolean {
        return this.getAddSref() === FiStateNames.ChecklistV2Audit.Report.Dashboard;
    }

    get isAddNewWidgetButtonShown$() {
        return this.fiChecklist2ReportHelperService.isAddNewWidgetButtonShown$;
    }
}
